import { Box, Typography } from '@mui/material'
import React from 'react'

export default function TitlePage({ title, action }) {
    return (
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '20px 0px' }}>
            <Box class="col-lg-4 col-md-12 text-left ">
                <Typography className="title-content">
                    {title}
                </Typography>
            </Box>
            <Box class="col-lg-8 col-md-12 text-left " style={{ display: 'flex', justifyContent: 'end', alignItems:'center' }}>
                {action}
            </Box>
        </Box >
    )
}
